import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl";

const API_URL = `${serverUrl}/categories`;

const createCategory = async (name) => {
  try {
    const response = await axiosInstance.post(API_URL, name);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

const addSubCategory = async (categoryId, subCategoryName) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/${categoryId}/subcategories`,
      { subCategoryName },
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

const getCategories = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};

const getCategoryById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/${id}`);
  return response.data;
};

const getSubCategories = async () => {
  const response = await axiosInstance.get(`${API_URL}/subcategories`);
  return response.data;
};

const getSubCategoryById = async (subCategoryId) => {
  const response = await axiosInstance.get(
    `${API_URL}/subcategory/${subCategoryId}`,
  );
  return response.data;
};

const categoryService = {
  createCategory,
  getSubCategories,
  addSubCategory,
  getCategories,
  getCategoryById,
  getSubCategoryById,
};

export default categoryService;
